import styled from 'styled-components';

import { useTranslation } from '@hooks';
import SummaryFeature from './SummaryFeature';

const CartSummaryContent = ({
    color,
    currency,
    discounts,
    extras,
    subtotal,
    cargoFee,
}) => {
    const { t } = useTranslation();
    return (
        <Wrapper>
            <SummaryFeature
                color={color}
                feature={currency ? subtotal + currency : subtotal}
                title={t('cartProductTotal')}
            />
            {extras?.gift_box && (
                <SummaryFeature
                    color={color}
                    title={t('giftBox')}
                    feature={extras.gift_box.price}
                />
            )}
            <SummaryFeature
                color={color}
                title="Cargo"
                feature={cargoFee}
            />
            {discounts?.COUPON?.discount_price && (
                <SummaryFeature
                    color={color}
                    title={t('coupon')}
                    discount
                    feature={discounts?.COUPON?.discount_price}
                />
            )}
            {discounts?.PRODUCT?.discount_price && (
                <SummaryFeature
                    color={color}
                    title={t('productDiscount')}
                    discount
                    feature={discounts?.PRODUCT?.discount_price}
                />
            )}
            {discounts?.CAMPAIGN?.discount_price && (
                <SummaryFeature
                    color={color || '#00ab00'}
                    discount
                    feature={discounts?.CAMPAIGN?.discount_price}
                    title={t('campaignTitle')}
                />
            )}
        </Wrapper>
    );
};
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;
export default CartSummaryContent;
